import Toastr from "../../../itrust_common/components/Toastr"

const DEFAULT_STATE = {
  reports: [],
  report: {},
  editing: false,
  meta: { pagination: {} },
  saving: false,
}

let changes = null;
export default function reportsReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)
  let updatedData = {}
  let reports = []
  let report = {}
  switch (action.type) {
    case 'REPORT_CREATE_PENDING':
    case 'REPORT_UPDATE_PENDING':
    case 'REPORT_DELETE_PENDING':
      return { ...state, saving: true };

    case 'REPORTS_LOAD_PENDING':
      return { ...state, saving: true, loading: true };

    case 'REPORTS_LOAD_REJECTED':
    case 'REPORT_CREATE_REJECTED':
    case 'REPORT_UPDATE_REJECTED':
    case 'REPORT_DELETE_REJECTED':
    case 'REPORT_FAX_LOAD_REJECTED':
    case 'REPORT_EMAIL_LOAD_REJECTED':
    case 'REPORT_PREVIEW_LOAD_REJECTED':
    case 'REPORT_LOAD_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = { saving: false, loading: false }
      return { ...state, ...changes };

    case 'REPORTS_LOAD_FULFILLED':
      changes = { ...response, saving: false, loading: false };
      return { ...state, ...changes };

    case 'REPORT_EMAIL_LOAD_FULFILLED':
      Toastr.handleShow(true, response.message, 201)
      return { ...state, ...changes };

    case 'REPORT_FAX_LOAD_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      return { ...state, ...changes };

    case 'REPORT_UPDATE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      changes = { report: response.report, saving: false }
      return { ...state, ...changes };

    case 'REPORT_CREATE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      changes = { report: response.report, saving: false }
      return { ...state, ...changes };

    case 'REPORT_LOAD_FULFILLED':
      changes = { report: response.report, saving: false }
      return { ...state, ...changes };

    case 'REPORT_DELETE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201);
      reports = [...state.reports];
      for (const [index, finding] of reports.entries()) {
        if (finding.id === response.report.id) {
          reports.splice(index, 1);
        }
      }
      return { ...state, reports: reports, saving: false };

    case 'REPORT_EDIT':
      changes = { editing: { ...state.editing, ...action.payload } }
      return { ...state, ...changes };

    case 'REPORT_RESET':
      return { ...state, report: {}, editing: false };

    default:
      return state;
  }
}